(() => {
  function initProductAccordions(scope = document) {
    const root = scope instanceof Element ? scope : document;
    const detailsList = root.querySelectorAll('.template-product .product__accordion details');

    if (!detailsList.length) {
      return;
    }

    const groups = new Map();
    detailsList.forEach((details) => {
      const key = details.closest('.product__info-container') || document.body;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key).push(details);
    });

    groups.forEach((group) => {

      group.forEach((details) => {
        if (details.dataset.lumireurAccordionInit === 'true') {
          return;
        }

        details.dataset.lumireurAccordionInit = 'true';

        details.addEventListener('toggle', () => {
          if (!details.open) {
            return;
          }

          group.forEach((other) => {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductAccordions(document));
  document.addEventListener('shopify:section:load', (event) => initProductAccordions(event.target));
})();
